import { render, staticRenderFns } from "./PostFooter.vue?vue&type=template&id=e42ad648&scoped=true&"
import script from "./PostFooter.vue?vue&type=script&lang=js&"
export * from "./PostFooter.vue?vue&type=script&lang=js&"
import style0 from "./PostFooter.vue?vue&type=style&index=0&id=e42ad648&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42ad648",
  null
  
)

export default component.exports